'use client';

import React from 'react';

import './account-profile.css';
import { useGetCurrentUser } from '../../../providers/queries/user-info';
import { UserEdit } from '../../layout/right-sidebar/user-edit';
import {
  getPlayerProfileFrameImageUrl,
  getPlayerProfileImageUrl,
} from '@wwe-portal/web/utils/avatar';

type Props = {
  userId: string;
  avatarUrl?: string;
  avatarFrameUrl?: string;
  avatarRarity?: string;
};

function AccountProfile({
  userId,
  avatarUrl,
  avatarFrameUrl,
  avatarRarity,
}: Props) {
  const currentUser = useGetCurrentUser();

  const frame = getPlayerProfileFrameImageUrl(
    userId,
    currentUser,
    avatarFrameUrl
  );

  return (
    <div className="relative">
      <div className="account-profile relative rounded-full">
        <UserEdit
          avatar={getPlayerProfileImageUrl(userId, currentUser, avatarUrl)}
          frame={frame}
          displayName={userId}
          rarity={avatarRarity}
          size={120}
          isShowAccount={currentUser?.userId === userId}
          isProfilePage
        />
      </div>
    </div>
  );
}

export default AccountProfile;
